<script>
  let { size = 24, class: className = '', viewBox= "0 0 24 24" } = $props();
</script>

<svg
  viewBox={viewBox}
  class={`inline-block ${className}`}
  fill="currentColor"
>
  <slot />
</svg>
